import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className='home-container'>
      <div className='home-hero-section'>
        <h1 className='home-title'>
          Welcome to <span className='home-title-highlight'>AirTestTool</span>
          <br />
          <span className='home-subtitle'>
            Optimizing QA Processes with Automated E2E Testing
          </span>
        </h1>
      </div>
    </div>
  );
}

export default Home;
